var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _rect, _path13, _circle, _circle2, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg404Error(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 201,
    viewBox: "0 0 139 201",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2554 181.642V146.551L56.3316 134.236V167.808L22.8517 183.132C21.6743 183.694 20.2554 182.879 20.2554 181.642Z",
    fill: "#F2D4BD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3014 200.845L21.2516 184.79C20.6478 184.509 20.2554 183.918 20.2554 183.271V146.55L56.3014 158.866V200.845Z",
    fill: "#F5DFCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7813 183.132L56.3315 167.808V134.236L92.3775 146.551V181.642C92.3775 182.879 90.9888 183.694 89.7813 183.132Z",
    fill: "#F2D4BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.053 133.701L92.3775 146.551L56.3315 134.236L69.9771 121.498L106.053 133.701Z",
    fill: "#F9EADE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6558 121.498L56.3316 134.236L20.2553 146.551L6.57959 133.701L42.6558 121.498Z",
    fill: "#F9EADE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3013 158.866L92.3775 146.55V183.271C92.3775 183.918 91.985 184.509 91.3812 184.79L56.3013 200.845V158.866Z",
    fill: "#F9EADE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2482 186.646L23.9687 180.656C23.4554 180.432 23.063 179.897 23.063 179.419V172.559C23.063 172.109 23.4554 171.912 23.9687 172.109L38.2482 178.098C38.7614 178.323 39.1539 178.857 39.1539 179.335V186.196C39.1539 186.645 38.7614 186.87 38.2482 186.646Z",
    fill: "#F9EADE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2174 132.493L49.9012 144.696L56.3013 158.867L20.2553 146.552L14.2174 132.493Z",
    fill: "#F2D4BD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4154 132.491L98.2645 132.829L92.3775 146.55L56.6938 158.725L56.3315 158.866L62.7317 144.694L98.4154 132.491Z",
    fill: "#F2D4BD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9389 158.725L49.6294 144.807L49.9011 144.695L50.1728 144.61L56.5125 158.557L56.2408 158.669L56.0295 158.753L55.9389 158.725Z",
    fill: "#F5DFCE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6294 144.807L14.1268 132.744L14.3382 132.21L50.1728 144.61L49.6294 144.807Z",
    fill: "#F9EADE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M98.506 132.744L98.2645 132.829L62.943 144.919L56.6938 158.725L56.3316 158.865L56.0297 158.753L62.4902 144.497L98.2947 132.21L98.4154 132.491L98.506 132.744Z",
    fill: "#F9EADE"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.9757,
    y: 45.6156,
    width: 91.2356,
    height: 55.5347,
    rx: 27.7674,
    transform: "rotate(-12.4641 15.9757 45.6156)",
    fill: "#F9EADE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.5593 39.1439C23.5853 42.4538 14.1296 57.2758 17.4394 72.2498C20.1305 84.4246 30.4318 92.9514 42.2375 93.935L41.041 94.1839L48.9335 102.31C49.422 102.813 50.2639 102.664 50.5501 102.024L54.8462 92.4191L85.4048 85.6645C100.379 82.3547 109.835 67.5326 106.525 52.5586C103.215 37.5845 88.3928 28.1288 73.4188 31.4387L38.5593 39.1439Z",
    fill: "#F9EADE"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 113.999,
    r: 4.5,
    fill: "#F9EADE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 125.999,
    r: 2.5,
    fill: "#F9EADE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1467 71.857L40.6029 69.2744L45.9668 56.6697L49.7938 55.8639L52.0482 66.5702L54.1143 66.1351L54.7175 68.9995L52.6513 69.4346L53.3533 72.7686L50.0663 73.4607L49.3643 70.1267L41.1467 71.857ZM47.4597 60.0333L44.1593 68.2313L48.9725 67.2178L47.4597 60.0333ZM54.9295 63.2663C54.3593 60.5584 54.398 58.3353 55.0454 56.5971C55.7085 54.8555 57.1749 53.7457 59.4445 53.2678C61.7141 52.7899 63.4957 53.2158 64.7891 54.5454C66.0982 55.8717 67.0379 57.8888 67.608 60.5967C68.1815 63.3202 68.1383 65.5606 67.4785 67.3178C66.8344 69.0718 65.3775 70.1877 63.1079 70.6656C60.8383 71.1435 59.0472 70.7114 57.7349 69.3695C56.4381 68.0242 55.503 65.9898 54.9295 63.2663ZM64.368 61.2789C64.1241 60.1206 63.8415 59.1666 63.5202 58.417C63.2112 57.6484 62.777 57.0614 62.2176 56.6561C61.6739 56.2475 60.9637 56.1355 60.0872 56.3201C59.2107 56.5046 58.5982 56.8951 58.2497 57.4916C57.9169 58.0848 57.7563 58.797 57.7679 59.6282C57.7918 60.4405 57.9257 61.4258 58.1696 62.5841C58.4201 63.7737 58.7014 64.7606 59.0137 65.5449C59.3227 66.3135 59.7568 66.9004 60.3162 67.3057C60.8723 67.6954 61.5886 67.7979 62.4652 67.6133C63.3417 67.4288 63.9559 67.0461 64.3076 66.4653C64.6561 65.8688 64.8167 65.1566 64.7895 64.3287C64.759 63.4851 64.6185 62.4685 64.368 61.2789ZM70.3805 65.7015L69.8367 63.1188L75.2006 50.5141L79.0276 49.7083L81.282 60.4146L83.3481 59.9795L83.9512 62.8439L81.8851 63.279L82.5871 66.613L79.3001 67.3051L78.5981 63.9711L70.3805 65.7015ZM76.6935 53.8777L73.3931 62.0757L78.2063 61.0622L76.6935 53.8777Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error);
export default __webpack_public_path__ + "static/media/404_error.3cb87ce0821a976f135033e0819fa4a3.svg";
export { ForwardRef as ReactComponent };